import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { EntityCommentRoutes } from "../../constants/entity-comment/entity-comment.constants";
import { EntityCommentModel } from "../../models/entity-comment/entity-comment.models";
import { PrivateNoteCountsResponse } from "../../models/vessels/vessel.models";

@autoinject
export class EntityCommentService {

    constructor(private requestClient: RequestClientService) { }

    public addComment(entityId: number, entityTypeId: number, comment: string, isPrivate: boolean): Promise<void> {
        return this.requestClient.post(`${EntityCommentRoutes.AddComment}`, {}, {
            entityId: entityId,
            entityTypeId: entityTypeId,
            comment: comment,
            isPrivate: isPrivate
        });
    }

    public updateComment(commentId: number, notes: string): Promise<void> {
        return this.requestClient.post(`${EntityCommentRoutes.UpdateComment}`, {}, {
            commentId: commentId,
            notes: notes
        });
    }

    public deleteComment(commentId: number): Promise<void> {
        return this.requestClient.post(`${EntityCommentRoutes.DeleteComment}`, {}, { commentId: commentId });
    }

    public getComments(entityId: number, entityTypeId: number, take: number, skip: number): Promise<EntityCommentModel[]> {
        return this.requestClient.get(`${EntityCommentRoutes.GetComments}/${entityId}/${entityTypeId}/${take}/${skip}`, {});
    }

    public getPrivateNoteCountsForEntity(entityId: number, entityTypeId: number): Promise<PrivateNoteCountsResponse> {
        return this.requestClient.get(`${EntityCommentRoutes.GetPrivateNoteCountsForEntity}/${entityId}/${entityTypeId}`, { });
    }
}
